import { modalController } from '@ionic/core';
import { PersonDoc } from 'common';
import { ConcoursePersonUpgradeProps } from './concourse-person-upgrade';

export class ConcoursePersonUpgradeController {
  static async presentModal(props: ConcoursePersonUpgradeProps): Promise<{ action: 'upgraded' | 'requested'; person: PersonDoc }> {
    console.log('ConcoursePersonUpgradeController.presentModal', props);
    const modal = await modalController.create({
      component: 'concourse-person-upgrade',
      cssClass: 'concourse-modal modal-height-auto',
      backdropDismiss: false,
      componentProps: props,
    });
    return new Promise<{ action: 'upgraded' | 'requested'; person: PersonDoc }>(async resolve => {
      modal.addEventListener('upgraded', (event: CustomEvent) => {
        resolve({ action: 'upgraded', person: event.detail });
        modal.dismiss();
      });

      modal.addEventListener('requested', (event: CustomEvent) => {
        resolve({ action: 'requested', person: event.detail });
        modal.dismiss();
      });

      modal.addEventListener('dismiss', () => {
        resolve(null);
        modal.dismiss();
      });

      await modal.present();
    });
  }
}
